import i18n from "@/lib/i18n/i18n"
import type { Verdict } from "./fuelReportTypes"

// The label is translated when called, so callers render it in the current
// UI language.
export function verdictDisplay(v: Verdict): {
  label: string
  emoji: string
  color: string
} {
  switch (v) {
    case "MATCH":
      return {
        label: i18n.t("reports.verdict.match"),
        emoji: "✅",
        color: "#14ae5c",
      }
    case "ELSEWHERE":
      return {
        label: i18n.t("reports.verdict.elsewhere"),
        emoji: "🟡",
        color: "#f59e0b",
      }
    case "NO_REFUEL":
      return {
        label: i18n.t("reports.verdict.noRefuel"),
        emoji: "⛽",
        color: "#6b7280",
      }
    case "NO_SUGGESTION":
      return {
        label: i18n.t("reports.verdict.noSuggestion"),
        emoji: "⛽",
        color: "#6b7280",
      }
    case "ERROR":
    default:
      return {
        label: i18n.t("reports.verdict.error"),
        emoji: "✖",
        color: "#dc2626",
      }
  }
}

export function formatFuelFraction(x: number | null | undefined): string {
  if (x === null || x === undefined || Number.isNaN(x)) return "—"
  const pct = x >= 0 && x <= 1 ? x * 100 : x
  return `${Math.round(pct)}%`
}
